var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-120 -460)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bg",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(120 460)",
    fill: "#263a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M6.117,194.556l17.971,19.183-8.654-19.183ZM29.54,216.825l10.067-22.269H19.473ZM15.521,190.863l5.885-11.077H13.848L5.54,190.863h9.981Zm19.471,22.875,17.971-19.183H43.646ZM19.7,190.863H39.377l-5.885-11.077h-7.9Zm23.856,0H53.54l-8.308-11.077H37.675Zm4.067-14.019L58.7,191.613a1.836,1.836,0,0,1-.115,2.365L30.9,223.517a1.881,1.881,0,0,1-2.712,0L.492,193.979a1.836,1.836,0,0,1-.115-2.365l11.077-14.769a1.685,1.685,0,0,1,1.471-.75H46.155a1.685,1.685,0,0,1,1.471.75Z",
    transform: "translate(142 311.906)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/values.343db82884c1721a1f3be86ef0ee9021.svg";
export { ForwardRef as ReactComponent };